 import { Input, DatePicker as AntDatePicker } from "antd";
import React from "react";
import styled from "styled-components";
import { device } from "../globalAssets/breakpoints";
import { mobile, desktop } from "../globalAssets/fontsize";

interface InputType {
  type?: string;
  placeholder?: string;
  name?: string;
  max?: number;
  min?: number;
  value?: string;
  required?: boolean;
  helperText?: string;
  onChange?: any;
}

export const TextInput: React.FC<InputType> = ({
  type,
  placeholder,
  // name,
  max,
  onChange,
  min,
  value,
  required,
  //   validateStatus,
  helperText,
}) => {
  return (
    <InputDiv>
      <StyledInputBorderless
        bordered={false}
        required={required ? true : false}
        type={type}
        maxLength={max}
        minLength={min}
        onChange={onChange}
        value={value}
        // name={name}
        placeholder={placeholder}
      />
    </InputDiv>
  );
};

export const PasswordInput: React.FC<InputType> = ({
  type,
  placeholder,
  // name,
  max,
  min,
}) => {
  return (
    <InputDiv>
      <StylePasswordBorderless
        bordered={false}
        type="password"
        required
        maxLength={max}
        // name={name}
        placeholder={placeholder}
      />
    </InputDiv>
  );
};

export const StyledInputBorderless = styled(Input)`
  &&& {
    outline: none;
    height: 100%;
    padding: 5px 10px;

    font-size: 14px;
    background: ${(props) => props.theme.foreground};
    color: ${(props) => props.theme.color};
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: ${mobile.small};
    }
    @media ${device.laptop} {
      font-size: ${desktop.small};
      .ant-input {
        font-size: ${desktop.small};
      }
    }
  }
`;

export const DatePicker = () => {
  return (
    // <InputDiv>
    <StyledDataPicker aria-required />
    // </InputDiv>
  );
};

const StyledDataPicker = styled(AntDatePicker)`
  ${"" /* outline: none; */}
  height: 100%;
  width: 100%;
  padding: 5px 10px;
  font-size: ${desktop.small};
  border: none;
  cursor: pointer;
  outline: none;
  background: ${(props) => props.theme.foreground};
  color: ${(props) => props.theme.color};
  font-size: 16px;
  .ant-picker-suffix {
    color: ${(props) => props.theme.color};
  }
  input {
    color: ${(props) => props.theme.color};
  }
  @media ${device.laptop} {
    font-size: ${desktop.small};
  }
`;

export const InputDiv = styled.div`
  width: 100%;
  height: 40px;
  border: 1px solid ${(props) => props.theme.subtleBlack};
  border-radius: 4px;
  padding: 0vw 0vw;
  :active,
  :focus,
  :hover {
    border: 2px solid ${(props) => props.theme.primaryColor};
  }
  @media ${device.laptop} {
    height: 2.5vw;
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
  }
`;

const StylePasswordBorderless = styled(Input.Password)`
  &&& {
    padding-left: 10px;
    outline: none;
    height: 100%;
    padding: 5px 10px;
    font-size: 14px;
    background: ${(props) => props.theme.foreground};
    border: none;

    .ant-input {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: 14px;
    }
    @media ${device.laptop} {
      font-size: ${desktop.small};
      .ant-input {
        font-size: ${desktop.small};
      }
    }
  }
`;
